import React from 'react';
import { Grid, IconButton, Typography } from 'e100-react-components';
import useStyles from './useStyles';
import { useMediaQuery } from 'common/hooks';
import { useMyFleetOperations } from '../../SearchCarMyFleet';
import { useIntl } from 'react-intl';

export const Title = () => {
  const { isMobile } = useMediaQuery();
  const classes = useStyles();
  const { setActiveDisplay } = useMyFleetOperations();
  const { formatMessage } = useIntl();

  return (
    <>
      <Grid container alignItems="center" wrap="nowrap" justify="space-between" classes={{ root: classes.container }}>
        <Grid item>
          <Grid container alignItems="center" wrap={'nowrap'}>
            {!isMobile && (
              <Grid item>
                <IconButton
                  classes={{ button: { root: classes.backIcon } }}
                  kind="arrowBack"
                  onClick={() => {
                    setActiveDisplay('carsList');
                  }}
                  id="back-to-route-form"
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <Typography variant="h6">{formatMessage({ id: 'filter' })}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
